export const referenceableTypes = Object.freeze({
  POST: 'Post',
  COMMENT: 'Comment',
  RATING: 'Rating',
});

export const notificationTypes = Object.freeze({
  REPLY_TO_COMMENT: 'WarRoom::Notifications::NewReplyToComment',
  MENTION_IN_COMMENT: 'WarRoom::Notifications::MentionComment',
  MENTION_IN_POST: 'WarRoom::Notifications::MentionPost',
  COMMENT: 'WarRoom::Notifications::NewCommentToPost',
  REACTION_TO_COMMENT: 'WarRoom::Notifications::NewReactionToComment',
  REACTION_TO_POST: 'WarRoom::Notifications::NewReactionToPost',
  OFFICIAL_POST: 'WarRoom::Notifications::OfficialPost',
  RECOMMENDED_POST: 'WarRoom::Notifications::RecommendedPost',
  CONTACTS_REMINDER: 'WarRoom::Notifications::ImportContactsReminder',
  TESTIMONIAL: 'WarRoom::Notifications::ReceivedTestimonial',
  MOBILE_APP_POST: 'WarRoom::Notifications::MobileAppLinkPost',
  REFERRALHIRED: 'WarRoom::Notifications::ReferralHired',
  REFERRAL: 'WarRoom::Notifications::Hired',
  JOB_INTRODUCTION: 'WarRoom::Notifications::JobsIntroduced',
  CONTRIBUTION_REWARD: 'WarRoom::Notifications::ContributionReward',
});
